// @ts-nocheck
import { Navigate } from "react-router-dom"
import { AdminUsersClient } from "@/components/admin/users/AdminUsersClient"
import { useAuth } from "@/components/layout/AuthProvider"

export default function AdminUsersPage() {
  const { user } = useAuth()
  if (!user || user.role !== "admin") return <Navigate to="/feed" replace />
  return <div className="container-app py-4"><AdminUsersClient /></div>
}